module.exports = "/packs/images/homepage/whatson/october_offers_mobile~c3aafb2e4067074902cedcafa2df8ee2.jpg";